var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteOutlined(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1979_15945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0508 2.45547C17.1406 1.6375 15.9727 1.21484 14.793 1.25C13.3285 1.25 11.8504 1.85156 10.7695 2.96797L10 3.75976L9.23047 2.96797C8.14844 1.85156 6.67188 1.25 5.20703 1.25C4.02734 1.25 2.86055 1.63789 1.91562 2.45547C-0.511721 4.55664 -0.633205 8.30312 1.55508 10.5648L9.10196 18.3656C9.35157 18.6211 9.67188 18.75 9.9961 18.75C10.3216 18.75 10.6481 18.6224 10.8949 18.367L18.4379 10.5662C20.6328 8.30078 20.5117 4.55468 18.0508 2.45547ZM17.0938 9.26171L10 16.5976L2.90391 9.26171C1.64453 7.96093 1.34609 5.39453 3.14297 3.87304C4.70156 2.52383 6.83789 3.18945 7.88516 4.27031L10.0012 6.45468L12.1168 4.27031C13.1488 3.20508 15.291 2.51679 16.859 3.87304C18.6367 5.41406 18.3789 7.93359 17.0938 9.26171Z",
    fill: "#E25297"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1979_15945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteOutlined);
export default __webpack_public_path__ + "static/media/favoriteOutlined.05d768e4e66aa7de427d68a7eea79b0f.svg";
export { ForwardRef as ReactComponent };